import { BaseWebComponentDataProvider } from '../../../framework/BaseWebComponentDataProvider';
import { DataGridItemsResponse, RelayCachingServer, RelayPatchCachingServersWebComponentSchema } from '../types';

export class RelayPatchCachingServersBaseDataProvider extends BaseWebComponentDataProvider {
  async getDataForView(): Promise<RelayPatchCachingServersWebComponentSchema> {
    throw new Error('Not implemented');
  }

  async getRelayServers(params: any): Promise<{ data: RelayCachingServer[] }> {
    throw new Error('Not implemented');
  }
}
